// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__18BAy","head":"Table_head__1ER8W","col":"Table_col__3W9Mm"};